// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditFlagsModal .RadioButton {
  width: 100%;
  justify-content: start;
  margin: 0.5rem 0;
}`, "",{"version":3,"sources":["webpack://./src/pages/Manifests/EditFlagsModal/styles.scss"],"names":[],"mappings":"AACE;EACE,WAAA;EACA,sBAAA;EACA,gBAAA;AAAJ","sourcesContent":[".EditFlagsModal {\n  .RadioButton {\n    width: 100%;\n    justify-content: start;\n    margin: 0.5rem 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
